import React from "react";
import Guest from "@/Layouts/Guest";
import { Link } from "@inertiajs/inertia-react";

const ErrorPage = ({ status = 404 }) => {
    const title = {
        503: "Service Unavailable",
        500: "Server Error",
        404: "Page Not Found",
        403: "Forbidden",
    }[status];

    const description = {
        503: "Sorry, we are doing some maintenance. Please check back soon.",
        500: "Whoops, something went wrong on our servers.",
        404: "Sorry, the page you are looking for could not be found.",
        403: "Sorry, you are forbidden from accessing this page.",
    }[status];

    return (
        <div className="min-h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
            <div className="mx-auto max-w-max">
                <main className="sm:flex">
                    <p className="text-4xl font-extrabold text-indigo-600 sm:text-5xl">
                        {status}
                    </p>
                    <div className="sm:ml-6">
                        <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                            <h1 className="tracking-light text-4xl font-extrabold text-gray-900 sm:text-5xl">
                                {title}
                            </h1>
                            <p className="mt-1 text-base text-gray-500">
                                {description}
                            </p>
                        </div>
                        <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                            <Link
                                href={route("dashboard")}
                                className="btn-base btn-primary"
                            >
                                Go back home
                            </Link>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

ErrorPage.layout = (page) => <Guest title={"Dashboard"} children={page} />;

export default ErrorPage;
